// src/components/aiondemand/useJobPolling.js

import { useEffect, useRef } from 'react';
import { useAIOnDemandStore } from '../../stores/useAIOnDemandStore';
import { useProjectStore } from '../../stores/useProjectStore';

const POLL_INTERVAL_MS = 5000;

export function useJobPolling() {
  const projectId = useProjectStore((s) => s.activeProjectId);
  const jobs = useAIOnDemandStore((s) => s.jobs);
  const refreshJobs = useAIOnDemandStore((s) => s.refreshJobs);

  const inflightCount = jobs.filter(
    (j) => j.status === 'queued' || j.status === 'running'
  ).length;

  const timerRef = useRef(null);

  useEffect(() => {
    if (!projectId) return;
    if (inflightCount === 0) {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
        timerRef.current = null;
      }
      return;
    }

    let cancelled = false;
    const tick = async () => {
      if (cancelled) return;
      await refreshJobs(projectId);
      if (cancelled) return;
      timerRef.current = setTimeout(tick, POLL_INTERVAL_MS);
    };

    timerRef.current = setTimeout(tick, POLL_INTERVAL_MS);

    return () => {
      cancelled = true;
      if (timerRef.current) {
        clearTimeout(timerRef.current);
        timerRef.current = null;
      }
    };
  }, [projectId, inflightCount, refreshJobs]);
}